<template>
    <div class="modal fade offer-modal" data-bs-backdrop="static" id="offer_pop_up" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content" style="border: none;">
                <div class="modal-body">
                    <div class="offer-pic" v-if="this.$siteSettings?.data?.offer?.image">
                        <button type="button" data-bs-dismiss="modal" @click="closeOffer" class="close btncloseset" data-dismiss="modal" aria-hidden="true">&#10006;</button>
                        <img loading="lazy" :src="this.$siteSettings.data?.aws_url + this.$siteSettings.data?.storage_path.poster_path + this.$siteSettings?.data?.offer?.image"
                            class="offer-img" alt="offer modal">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    methods: {
        closeOffer() {
            localStorage.setItem('is_offer', false);
        }
    }
}
</script>